import {
  getReservationNames,
  phoneNumber,
  phoneNumberLink,
  toSentence,
} from 'utils/helpers';

const buttonText = {
  accommodation: {
    confirm: 'Remove accommodation and proceed',
    cancel: 'Close',
    canClose: true,
  },
  ferry: {
    confirm: 'Remove experience and proceed',
    cancel: 'Go Back',
    canClose: false,
  },
  experience: { cancel: 'Close', canClose: true },
};

const callMeWithReference = (reference) => (
  <>
    &nbsp;please call&nbsp;
    <a className="text-reset" href={`tel:${phoneNumberLink}`}>
      {phoneNumber}
    </a>
    &nbsp; and quote your booking reference: <strong>{reference}</strong>
  </>
);

const contentOfFerry = (reservationsTobeDeleted, reference) => (
  <>
    Your experience booking already contains a ferry trip. To add another ferry
    booking, you will remove the&nbsp;
    <strong>{getReservationNames(reservationsTobeDeleted)}</strong> from your
    cart.
    <br />
    <br />
    To add a ferry booking in addition to your experience,
    {callMeWithReference(reference)}
  </>
);

const contentOfAccommodation = (reservationsTobeDeleted, reference) => (
  <>
    Your booking already contains accommodation. To book this accommodation, you
    will remove the&nbsp;
    <strong>{getReservationNames(reservationsTobeDeleted)}</strong> from your
    booking.
    <br />
    <br />
    To include multiple accommodation reservations,
    {callMeWithReference(reference)}
  </>
);

const contentOfExperience = (
  reservationsTobeDeleted,
  reference,
  reservationTypes
) => (
  <>
    You already have {toSentence(reservationTypes)} added to your booking. To
    purchase this experience, you will need to remove the&nbsp;
    <strong>{getReservationNames(reservationsTobeDeleted)}</strong> from your
    booking.
    <br />
    <br />
    If you need any help on purchasing,
    {callMeWithReference(reference)}
  </>
);

const getModalContent = (
  scene,
  reservationsTobeDeleted,
  reference,
  reservationTypes
) => {
  let result = '';
  if (scene === 'ferry') {
    result = contentOfFerry(reservationsTobeDeleted, reference);
  } else if (scene === 'accommodation') {
    result = contentOfAccommodation(reservationsTobeDeleted, reference);
  } else if (scene === 'experience') {
    result = contentOfExperience(
      reservationsTobeDeleted,
      reference,
      reservationTypes
    );
  }
  return result;
};

export { buttonText, getModalContent };
